import { render, staticRenderFns } from "./ADRegion.vue?vue&type=template&id=420f314c&"
import script from "./ADRegion.vue?vue&type=script&lang=js&"
export * from "./ADRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports